"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = exports.getQnaUserId = exports.getUserId = exports.generateId = void 0;
var generateId = function () {
    return new Date().getTime().toString(36) + Math.random().toString(36).slice(2);
};
exports.generateId = generateId;
var generateNumberedId = function () {
    var uuid = (0, exports.generateId)();
    var numStr = '';
    for (var i = 0; i < uuid.length; i++) {
        var char = uuid.charAt(i);
        numStr += Number.isNaN(+char) ? char.charCodeAt(0) : char;
    }
    return numStr;
};
function getUserId() {
    if (typeof Storage === 'undefined') {
        // No web storage Support, just generate and return a anonymous user id
        return _generateAnonymousUserId();
    }
    // Web storage is supported
    var anonymousUserId;
    anonymousUserId = localStorage.getItem('anonymousUserId');
    if (!anonymousUserId) {
        anonymousUserId = _generateAnonymousUserId();
        localStorage.setItem('anonymousUserId', anonymousUserId);
    }
    return anonymousUserId;
}
exports.getUserId = getUserId;
// makes uniq user id for push notification client
var getQnaUserId = function (player) {
    var _a, _b, _c, _d;
    var _e = player, config = _e.config, plugins = _e.plugins;
    var session = (config === null || config === void 0 ? void 0 : config.session) || {};
    var userRole = ((_b = (_a = plugins === null || plugins === void 0 ? void 0 : plugins.qna) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.userRole) || session.userRole;
    if (!userRole || userRole === 'anonymousRole') {
        return getUserId();
    }
    return ((_d = (_c = plugins === null || plugins === void 0 ? void 0 : plugins.qna) === null || _c === void 0 ? void 0 : _c.config) === null || _d === void 0 ? void 0 : _d.userId) || session.userId;
};
exports.getQnaUserId = getQnaUserId;
function _generateAnonymousUserId() {
    var HashSeparatorText = 'HashSeparator';
    var DefaultAnonymousPrefix = 'Guest';
    return "##".concat(DefaultAnonymousPrefix).concat(HashSeparatorText).concat(generateNumberedId(), "##");
}
function debounce(func, waitMilliseconds, options) {
    if (waitMilliseconds === void 0) { waitMilliseconds = 50; }
    if (options === void 0) { options = {
        isImmediate: false
    }; }
    var timeoutId;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var doLater = function () {
            timeoutId = undefined;
            if (!options.isImmediate) {
                func.apply(_this, args);
            }
        };
        var shouldCallNow = options.isImmediate && timeoutId === undefined;
        if (timeoutId !== undefined) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(doLater, waitMilliseconds);
        if (shouldCallNow) {
            func.apply(this, args);
        }
    };
}
exports.debounce = debounce;
//# sourceMappingURL=utils.js.map